export const ORGANIZATION_ROUTES = {
  __ROOT__: '/organization',
  EDIT_ORGANIZATION_INFO: '/organization/edit',
}
